var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconTrashRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1079_20773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.85682H17.5M15.8333 4.85682V15.8239C15.8333 16.6072 15 17.3905 14.1667 17.3905H5.83333C5 17.3905 4.16667 16.6072 4.16667 15.8239V4.85682M7.5 4.85682V3.2901C7.5 2.50674 8.33333 1.72339 9.16667 1.72339H10.8333C11.6667 1.72339 12.5 2.50674 12.5 3.2901V4.85682M8.33333 8.77362V13.4738M11.6667 8.77362V13.4738",
    stroke: "#B42318",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1079_20773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18.8006,
    fill: "white",
    transform: "translate(0 0.156738)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconTrashRed);
export default __webpack_public_path__ + "static/media/common_icon_trash_red.bbf1e7c2820639f3eb1a3910776682f1.svg";
export { ForwardRef as ReactComponent };